import classNames from "classnames"
import React from "react"

import LayoutSection from "../LayoutComponents/LayoutSection"
import LayoutItem from "../Layouts/LayoutItem"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import {
  getAccentColor,
  getBackgroundColorClass,
  getBorderColorClass,
} from "@utils/V2/color"

type Props = {
  title: string
  hideBorder: boolean
  backgroundColor?: Color
  borderColor?: Color
  highlightedWords?: string[]
  mobileGridOrder?: number
  sectionColor?: Color
}

const HeaderBanner = ({
  title,
  hideBorder,
  backgroundColor,
  borderColor,
  highlightedWords,
  mobileGridOrder,
  sectionColor = Color.White,
  ...props
}: Props) => {
  return (
    <LayoutItem
      as={LayoutSection}
      primaryBackgroundColor={sectionColor}
      mobileGridOrder={mobileGridOrder}
      {...props}
    >
      <div
        className={classNames(
          "flex items-center justify-center",
          backgroundColor && getBackgroundColorClass(backgroundColor),
          hideBorder
            ? "border-0"
            : [
                "rounded-10 border border-opacity-20 px-10 py-20",
                borderColor
                  ? getBorderColorClass(borderColor)
                  : "border-current",
              ]
        )}
      >
        <Typography
          text={title}
          size="lead-sm"
          weight="medium"
          font="grotesk"
          color={getAccentColor(backgroundColor || Color.White)}
          highlightedText={highlightedWords}
        />
      </div>
    </LayoutItem>
  )
}

export default HeaderBanner
